import React from 'react';
import InstructionsDialog from '../../../InstructionsDialog';
import { RubigramStore } from '../RubigramStore';
import { isMobile, isTablet } from 'react-device-detect';
import Cookies from 'js-cookie';
import { PuzzleNames } from '../../../../utils/types';
import { DOMAIN } from '../../shared/utils';
import InstructionsVideo_mp4 from 'url:./videos/Rubigram.mp4';
import InstructionsVideo_webm from 'url:./videos/Rubigram.webm';

const closeInstructions = () => {
  RubigramStore.update(s => {
    s.instructionsAreOpen = false;
    s.isSoftPaused = false;
  });

  Cookies.set(`${PuzzleNames.Rubigram}InstructionsDismissed`, 'true', {
    domain: DOMAIN,
    expires: 365,
  });
};

const Instructions = () => {
  const isOpen = RubigramStore.useState(s => s.instructionsAreOpen);
  const isTouch = isMobile || isTablet;

  return (
    <InstructionsDialog isOpen={isOpen} onClose={closeInstructions} className="twoColumnInstructions">
      <h1 className="instructionsTitle">How to Play the Rubigram</h1>
      <div className="instructionsBody twoColumnInstructionsBody">
        <div className="writtenInstructions">
          <ul>
            <li>Rotate and flip until every full row and column spells a 6-letter word from left-to-right and top-to-bottom.</li>
            <li>Flip the 3x3 subgrids by {isTouch ? 'tapping' : 'clicking'} their non-corner cells.</li>
            {!isTouch && <li>Right-click the rotate buttons to rotate counterclockwise.</li>}
            <li>No very obscure words or proper names.</li>
          </ul>
        </div>
        <div className="videoInstructions">
          <video controls autoPlay>
            <source src={InstructionsVideo_webm} type="video/webm" />
            <source src={InstructionsVideo_mp4} type="video/mp4" />
            <p>Your browser does not support HTML5 video elements.</p>
          </video>
        </div>
      </div>
    </InstructionsDialog>
  );
};

export default Instructions;